import { useWindowSize } from '@react-hook/window-size/throttled';
import classNames from 'classnames';
import _ from 'lodash';
import { contextMenu } from 'react-contexify';
import { EditTextarea } from 'react-edit-text';
import TextTruncate from 'react-text-truncate';
import {
  AUTHOR_MENU_ID,
  CONTEXT_MENU_ID,
  CUSTOM_COLUMN_KEY,
  DEFAULT_AUTHOR_NAME,
  IMAGE_TYPE,
  LEASE_STATUS,
  LOI_SHARE_MENU_ID,
  MARKET_MENU_ID,
  MENU_SUB_TYPE,
  NONE_MENU_ID,
  REMINDER_MENU_ID,
  STATUS_MENU_ID,
} from '../../../../common/constants';
import { DocumentEntity, DocumentFieldValuesEntity } from '../../../../common/types/EntityTypes';
import { CustomCellParams } from '../../../../common/types/dashboard/DashboardUITypes';
import { getImage, getImageSize } from '../../../../common/util';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import {
  fetchDocumentHTML,
  rowCollapseUpdate,
  rowExpandUpdate,
  selectCurrentTab,
  selectSelectedDocumentExpandedId,
  selectSelectedDocumentId,
  setDocumentExpanded,
  updateDocumentAuthor,
} from '../../../../redux/reducers/dashboardSlice';
import '../Table.scss';
import '../../../popup/lease-status/LeaseStatus.scss';
import { selectAuthors, selectMarkets } from '../../../../redux/reducers/metadataSlice';
import {
  selectMenu,
  setAbstraction,
  setFieldToBeSelectedInEdit,
  setIsLOISharePopupActive,
  setLOIPopupOffset,
  setMenu,
} from '../../../../redux/reducers/popupSlice';
import { setDocumentNotes, setDocumentTradeArea } from '../../../../redux/thunks';
import {
  selectRows,
  setDocumentRowAsExpanded,
} from '../../../../redux/reducers/documentsDataSlice';
import EditableCellIndicator from '../../../../assets/images/dashboard/table/EditableCellIndicator.svg';
import CellIndicatorWhite from '../../../../assets/images/dashboard/table/StatusMenuIconWhite.svg';
import {
  selectedRelatedUnmatchedDocs,
  selectParentsWithChildren,
  selectRelatedUnmatchedDocuments,
} from '../../../../redux/reducers/documentsSlice';
import {
  selectUserActiveRowHeight,
  selectUserInactiveRowHeight,
} from '../../../../redux/reducers/settingsSlice';
import { selectReadOnlyApp } from '../../../../redux/reducers/appSlice';
import { normalizeText } from '../table-util';
import HideChildren from '../../../../assets/images/dashboard/table/hide/1366.svg';
import HideChildrenWhite from '../../../../assets/images/dashboard/table/hide/white.svg';
import ShowChildren from '../../../../assets/images/dashboard/table/show/1366.svg';
import ShowChildrenWhite from '../../../../assets/images/dashboard/table/show/white.svg';
import { useEffect, useState } from 'react';
import bellIcon from '../../../../assets/images/dashboard/table/bellIcon.svg';
import bellIconWhite from '../../../../assets/images/dashboard/table/bellIconWhite.svg';
import {
  selectDocumentReminderId,
  setReminder,
  setReminderId,
} from '../../../../redux/reducers/documentSlice';
import DotProgress from '../../progressbar/DotProgressBar';
import ApEditDocIcon from '../../../../assets/images/dashboard/header/ap_edit_doc_white_icon.svg';
import ApLOISharedWhiteIcon from '../../../../assets/images/dashboard/header/ap_loi_shared_white_icon.svg';
import ApLOISharedBlackIcon from '../../../../assets/images/dashboard/header/ap_loi_shared_black_icon.svg';
import { selectAllSharedDocIds, selectUserSharedLOIList } from '../../../../redux/reducers/sidebarSlice';

function TableCell(props: CustomCellParams) {
  const [width, height] = useWindowSize();

  const dispatch = useAppDispatch();
  const isReadOnly = useAppSelector(selectReadOnlyApp);
  const authors = useAppSelector(selectAuthors);
  const markets = useAppSelector(selectMarkets);
  const selectedTab = useAppSelector(selectCurrentTab);
  const selectedRowId = useAppSelector(selectSelectedDocumentId);
  const selectedMenu = useAppSelector(selectMenu);
  const parentsWithChildren = useAppSelector(selectParentsWithChildren);
  const expandedDocumentId = useAppSelector(selectSelectedDocumentExpandedId);

  const userMaxNoLines = Number(useAppSelector(selectUserActiveRowHeight).value);
  const userMinNoLines = Number(useAppSelector(selectUserInactiveRowHeight).value);
  const selectedFilterData = useAppSelector(selectRows)[useAppSelector(selectCurrentTab)];
  const unMatchedRelatedDocIds = useAppSelector(selectedRelatedUnmatchedDocs);
  const unMatchedRelatedDocuments = useAppSelector(selectRelatedUnmatchedDocuments);
  const activeReminderId = useAppSelector(selectDocumentReminderId);

  let [isChildExists, setIsChildExists] = useState<boolean>(false);
  const [authorToggle, setAuthorToggle] = useState<boolean>(false);

  // LOI Share Menu State
  const isLOIShareMenuActive = selectedMenu === 'loi-share-menu-id';
  const userSharedDocIds = useAppSelector(selectAllSharedDocIds);
  

  useEffect(() => {
    setIsChildExists(parentsWithChildren.includes(props.data.id) && props.data.parent === '');
  }, [parentsWithChildren, props.data.id, props.data.parent]);

  function getAuthor(authorId: any) {
    let selectedAuthor = authors?.find((author) => authorId == author.externalId);
    if (selectedAuthor == null || selectedAuthor == undefined) {
      selectedAuthor = authors?.find((author) => author.name == DEFAULT_AUTHOR_NAME);
    }

    return selectedAuthor?.name;
  }

  function getMarkets(marketId: any) {
    let selectedMarket = markets?.find((market) => marketId == market.externalId);

    if (selectedMarket == null || selectedMarket == undefined) {
      selectedMarket = markets?.find((market) => market.name == DEFAULT_AUTHOR_NAME);
    }
    return selectedMarket?.name;
  }

  function displayMenu(e: React.MouseEvent<HTMLElement>, data: string, menuType: string) {
    if (
      e.currentTarget.offsetParent != null &&
      e.currentTarget.offsetParent != undefined &&
      !isReadOnly
    ) {
      let parentDoc = e.currentTarget.offsetParent?.getBoundingClientRect();
      let xPos = parentDoc.left + parentDoc.width + 5;
      let yPos = parentDoc.top + 5;
      if (menuType == MENU_SUB_TYPE.STATUS) {
        dispatch(setMenu(STATUS_MENU_ID));
      } else if (menuType == MENU_SUB_TYPE.AUTHOR) {
        dispatch(setMenu(AUTHOR_MENU_ID));
      } else if (menuType == MENU_SUB_TYPE.MARKET) {
        dispatch(setMenu(MARKET_MENU_ID));
      } else if (menuType == MENU_SUB_TYPE.CONTEXT_MENU) {
        dispatch(setMenu(CONTEXT_MENU_ID));
        xPos = e.clientX + 5;
        yPos = e.clientY + 5;
      } else if (menuType === MENU_SUB_TYPE.REMINDER_MENU) {
        dispatch(setMenu(REMINDER_MENU_ID));
      }

      contextMenu.show({
        id: selectedMenu,
        event: e,
        props: { data },
        position: {
          x: xPos,
          y: menuType == MENU_SUB_TYPE.MARKET ? yPos : e.clientY - 10,
        },
      });
    }
  }

  const toggleReminderMenu = (e: any) => {
    const id = (e.currentTarget as HTMLElement).id;
    if (
      selectedMenu === NONE_MENU_ID ||
      (id === 'reminderCol' && activeReminderId !== props.data.id)
    ) {
      dispatch(setReminderId(props.data.id));
      dispatch(setReminder(props.data.reminderDate));
      displayMenu(e, props.data, MENU_SUB_TYPE.REMINDER_MENU);
    } else {
      dispatch(setReminderId(''));
      dispatch(setMenu(NONE_MENU_ID));
      dispatch(setReminder(false));
    }
  };

  const formatUploadDate = (dateString?: string) => {
    if (!dateString) return 'None';
    const date = new Date(dateString);

    const weekday = date.toLocaleDateString('en-US', { weekday: 'short' });
    const month = date.toLocaleDateString('en-US', { month: 'short' });
    const day = date.getDate();
    const year = date.getFullYear();

    // Format time
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'p.m.' : 'a.m.';

    hours = hours % 12 || 12; // convert 0 -> 12 for 12hr clock

    return `${weekday}, ${month} ${day}, ${year} - ${hours}:${minutes} ${ampm}`;
  };

  const formatReminderDate = (reminderDateStr: any) => {
    if (reminderDateStr === undefined || reminderDateStr === '' || reminderDateStr === null) {
      return <div className='reminder-none'>&nbsp;</div>;
    }

    // --- Parse as UTC, convert to local ---
    const reminderDate = new Date(reminderDateStr);
    // --- Localize all logic to local midnight ---
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    const dayName = weekdays[reminderDate.getDay()];
    const monthName = months[reminderDate.getMonth()];
    const diffDays = Math.floor((reminderDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
    const diffWeeks = Math.floor(diffDays / 7);

    // Today
    if (today.getDate() === reminderDate.getDate()) {
      return (
        <div>
          Today <br />
          <span className='text-bolder'>{dayName}</span>
        </div>
      );
    }

    // Next year: full format
    if (reminderDate.getFullYear() > today.getFullYear()) {
      return (
        <div>
          {dayName}
          <br />
          <div>
            {monthName} {reminderDate.getDate()} {reminderDate.getFullYear()}
          </div>
        </div>
      );
    }

    // Past Due
    if (reminderDate < today) {
      return (
        <div>
          <span>{`Past Due`}</span> <br />
          <span className='text-bolder'>
            {dayName}, {monthName} {reminderDate.getDate()}
          </span>
        </div>
      );
    }

    // Tomorrow
    if (diffDays === 1) {
      return (
        <div>
          Tomorrow
          <br />
          <span className='text-bolder'>{dayName}</span>
        </div>
      );
    }

    // This week (between today and this Sunday)
    const thisWeekStart = new Date(today);
    thisWeekStart.setDate(today.getDate() - today.getDay());
    thisWeekStart.setHours(0, 0, 0, 0);
    const thisWeekEnd = new Date(thisWeekStart);
    thisWeekEnd.setDate(thisWeekStart.getDate() + 6);
    if (reminderDate > today && reminderDate <= thisWeekEnd) {
      return (
        <div>
          This Week <br />
          <span className='text-bolder'>{dayName}</span>
        </div>
      );
    }

    // Next week (after this week)
    const nextWeekStart = new Date(thisWeekEnd);
    nextWeekStart.setDate(thisWeekEnd.getDate() + 1);
    nextWeekStart.setHours(0, 0, 0, 0);
    const nextWeekEnd = new Date(nextWeekStart);
    nextWeekEnd.setDate(nextWeekStart.getDate() + 6);
    if (reminderDate >= nextWeekStart && reminderDate <= nextWeekEnd) {
      return (
        <div>
          Next Week <br /> <span className='text-bolder'>{dayName}</span>
        </div>
      );
    }

    // Week after next
    const weekAfterNextStart = new Date(nextWeekEnd);
    weekAfterNextStart.setDate(nextWeekEnd.getDate() + 1);
    weekAfterNextStart.setHours(0, 0, 0, 0);
    const weekAfterNextEnd = new Date(weekAfterNextStart);
    weekAfterNextEnd.setDate(weekAfterNextStart.getDate() + 6);
    if (reminderDate >= weekAfterNextStart && reminderDate <= weekAfterNextEnd) {
      return (
        <div>
          Week after <br /> next <span className='text-bolder'>{dayName}</span>
        </div>
      );
    }

    // 2-4 weeks (2 Weeks Fri ...)
    if (diffWeeks >= 2 && diffWeeks <= 4) {
      return (
        <div>
          {diffWeeks} Weeks <br /> <span className='text-bolder'>{dayName}</span>
        </div>
      );
    }

    // Remainder of this year: short date
    const yearEnd = new Date(today.getFullYear(), 11, 31, 0, 0, 0, 0);
    if (reminderDate > weekAfterNextEnd && reminderDate <= yearEnd) {
      return (
        <div>
          <span>{dayName}</span>
          <br />
          <span className='text-bolder'>
            {monthName} {reminderDate.getDate()}
          </span>
        </div>
      );
    }

    // Default fallback: full date
    return (
      <div>
        {dayName}
        <br />
        <div>
          {monthName} {reminderDate.getDate()}, {reminderDate.getFullYear()}
        </div>
      </div>
    );
  };

  function handleNotes(input: { name: string; value: string; previousValue: string }): void {
    if (input.value !== input.previousValue) {
      dispatch(
        setDocumentNotes({
          id: props.data.id,
          notes: input.value,
        }),
      );
    }
  }

  function handleTrade(input: { name: string; value: string; previousValue: string }): void {
    if (input.value !== input.previousValue) {
      dispatch(
        setDocumentTradeArea({
          id: props.data.id,
          trade: input.value,
        }),
      );
    }
  }

  function handleToggleAuthor(prevAuthor: any, e: React.MouseEvent<HTMLDivElement>) {
    let isSingle = false;
    if (e.shiftKey) {
      isSingle = true;
    }
    setAuthorToggle(true);
    if (prevAuthor !== '') {
      let nextAuthorId;
      if (prevAuthor == 'Tenant') {
        nextAuthorId = authors.filter((e) => e.name.toLowerCase() === 'LandLord'.toLowerCase())[0]
          ?.externalId;
      } else {
        nextAuthorId = authors.filter((e) => e.name.toLowerCase() === 'Tenant'.toLowerCase())[0]
          ?.externalId;
      }
      if (nextAuthorId) {
        dispatch(
          updateDocumentAuthor({
            documentId: props.data.id,
            authorExternalId: nextAuthorId,
            isSingle,
          }),
        ).then((e) => {
          if (e.payload?.data) {
            setAuthorToggle(false);
          }
        });
      }
    } else {
      setAuthorToggle(false);
    }
  }

  const getCSSForLeaseStatus = (isParentChildValueDiffers?: boolean) => {
    let cssClasses = '';
    if (isParentChildValueDiffers) {
      cssClasses = cssClasses + ' parent-child-value-differs ';
    }
    if (
      (unMatchedRelatedDocIds.includes(props.data.id) && !isParentChildValueDiffers) ||
      (props.data.parent === '' &&
        parentsWithChildren.includes(props.data.id) &&
        !isParentChildValueDiffers &&
        isReadOnly)
    ) {
      cssClasses = cssClasses + ' unmatched-document-values ';
    }
    return cssClasses;
  };

  function handleEditDocMenu(e: React.MouseEvent<HTMLElement>) {
    e.stopPropagation();
    dispatch(setFieldToBeSelectedInEdit({ fieldCode: 'edit-hidden', value: 'edit-hidden' }));
    dispatch(setMenu(NONE_MENU_ID));
    dispatch(setAbstraction());
    dispatch(fetchDocumentHTML());
  }

  function getData() {
    const headerKey = props.customData?.code;
    const status = props.data.status;
    let maxNoOfLines = userMaxNoLines,
      minNoOfLines = userMinNoLines;

    if (props.data.status == LEASE_STATUS.DUMMY) {
      return '';
    }
    if (headerKey == CUSTOM_COLUMN_KEY.PIN) {
      if (selectedRowId !== props.data.id) {
        return;
      }
      return (
        <div className={classNames('flex  fit-container flex-align-center')}>
          {/* Add compare feature here */}
          {/* <img
            // width={dim.width}
            // height={dim.height}
            id="pin"
            src={src}
          ></img> */}
        </div>
      );
    } else if (headerKey == CUSTOM_COLUMN_KEY.STATUS) {
      const dim = getImageSize(width, height, IMAGE_TYPE.STATUS);
      const state = props.data.status;
      let imgSrc = getImage(width, height, IMAGE_TYPE.STATUS, state);
      let tradeArea = props.data.trade == '' ? 'Enter Trade Area' : props.data.trade;
      const author = getAuthor(props.data.author);
      const authorClass = 'ap-author-' + getAuthor(props.data.author)?.toLowerCase();
      const isChild = props.data.parent === '';
      return (
        <section className={classNames('flex', 'combined-status-col')}>
          {!isChild ? (
            // Child: Only show the bottom part, but keep same container for alignment
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '5px',
              }}>
              <br />
              <div
                className='status-bottom-part'
                onClick={(e: React.MouseEvent<HTMLDivElement>) => handleToggleAuthor(author, e)}>
                {!authorToggle ? (
                  <div className='author-toggle-holder'>
                    <span className={classNames('ap-author-text', authorClass)}>{author}</span>
                  </div>
                ) : (
                  <DotProgress />
                )}
              </div>
            </div>
          ) : (
            // Parent: Full structure
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '5px',
              }}>
              <div
                className={classNames(
                  'flex',
                  'fit-container',
                  'ag-cell-font-common',
                  'editable-cell',
                  'loi-status-font-weight-parent',
                )}
                onClick={(e) =>
                  selectedMenu === NONE_MENU_ID
                    ? displayMenu(e, props.data, MENU_SUB_TYPE.STATUS)
                    : dispatch(setMenu(NONE_MENU_ID))
                }>
                <div className={classNames(props.data.read ? 'text-read' : 'text-read')}>
                  {_.startCase(_.lowerCase(_.replace(state, '_', ' ')))}
                </div>
                <div
                  className={classNames(
                    'indicator',
                    isReadOnly ? 'visible-hidden' : 'visibilty-not-hiddent',
                  )}>
                  <img
                    src={
                      selectedRowId === props.data.id ? CellIndicatorWhite : EditableCellIndicator
                    }
                    alt='&gt;'
                  />
                </div>
              </div>
              <div
                className='status-bottom-part'
                onClick={(e: React.MouseEvent<HTMLDivElement>) => handleToggleAuthor(author, e)}>
                {!authorToggle ? (
                  <div className='author-toggle-holder'>
                    <span className={classNames('ap-author-text', authorClass)}>{author}</span>
                  </div>
                ) : (
                  <DotProgress />
                )}
              </div>
            </div>
          )}
        </section>
      );
    } else if (headerKey == CUSTOM_COLUMN_KEY.NOTES) {
      const notes = props.data.notes == '' ? 'Enter Deal Notes and Next Steps' : props.data.notes;
      return isReadOnly ? (
        <div className={classNames('ta-input-label', 'custom-scroll')}>
          {props.data.notes.replace(/\. /g, '.\n')}
        </div>
      ) : (
        <EditTextarea
          inputClassName={classNames(
            'ag-cell-font-common',
            'ta-text-area',
            'ta-input',
            // props.data.read ? "text-read" : "text-unread"
          )}
          placeholder={notes}
          // placeholder={props.data.id.split('-')[0] + '-' +  props.data.parent.split('-')[0]}
          className={classNames(
            // props.data.read ? "text-read" : "text-unread",
            selectedRowId === props.data.id ? 'ta-input-row-active' : '',
            'ta-input-label',
            props.data.notes.trim().length > 0 && 'custom-scroll',
          )}
          defaultValue={props.data.notes}
          onSave={handleNotes}
          rows={13}
        />
      );
    } else if (headerKey == CUSTOM_COLUMN_KEY.REMINDER) {
      const isChild = props.data.parent !== '';
      if (isChild) {
        return '';
      } else {
        return props?.data?.reminderDate !== null &&
          props?.data?.reminderDate !== '' &&
          props?.data?.reminderDate !== undefined ? (
          <div id='reminderCol' className='reminder-cell' onClick={toggleReminderMenu}>
            <div>{formatReminderDate(props.data?.reminderDate)}</div>
            {selectedRowId === props.data.id ? <img src={bellIconWhite} /> : <img src={bellIcon} />}
          </div>
        ) : (
          <div id='reminderCol' className='reminder-none' onClick={toggleReminderMenu}></div>
        );
      }
    } else if (headerKey == CUSTOM_COLUMN_KEY.EDIT_HIDDEN) {
      const isSelected = selectedRowId === props.data.id;
      return isSelected ? (
        <div
          className='flex  fit-container cursor-pointer expand-collapse-cell'
          onClick={handleEditDocMenu}>
          <img className={classNames('expand-collapse-icon')} src={ApEditDocIcon}></img>
        </div>
      ) : (
        ''
      );
    } else if (headerKey == CUSTOM_COLUMN_KEY.SHARED) {
      const isSelected = selectedRowId === props.data.id;
      const isShared = userSharedDocIds.includes(props.data.id);
      return isShared ? (
        <div
          className='flex  fit-container cursor-pointer shared-cell'
        >
          <img
            className={classNames('expand-collapse-icon')}
            src={isSelected ? ApLOISharedWhiteIcon : ApLOISharedBlackIcon}></img>
        </div>
      ) : '';
    } else if (headerKey == CUSTOM_COLUMN_KEY.REMINDER_HIDDEN) {
      return (
        <div className='reminder-none' onClick={toggleReminderMenu}>
          &nbsp;
        </div>
      );
    } else if (headerKey == CUSTOM_COLUMN_KEY.DOCUMENT_HIDDEN) {
      return <div>{''}</div>;
    } else if (headerKey == CUSTOM_COLUMN_KEY.DOCUMENT_NAME) {
      const docName = props.data.name;
      return (
        <div title={docName}>
          <TextTruncate
            containerClassName={classNames(
              'ag-cell-font-common',
              // props.data.read ? "text-read" : "text-unread"
            )}
            line={minNoOfLines - 1}
            textElement='div'
            text={docName}
          />
          <div className='ag-cell-font-common'>{formatUploadDate(props.data?.ts)}</div>
        </div>
      );
    } else if (headerKey == CUSTOM_COLUMN_KEY.CHILDREN) {
      const isExpanded = expandedDocumentId === props.data.id;
      const isRowActive = selectedRowId === props.data.id;
      let imgSrc;
      if (isRowActive) {
        imgSrc = isExpanded ? HideChildrenWhite : ShowChildrenWhite;
      } else {
        imgSrc = isExpanded ? HideChildren : ShowChildren;
      }
      return (
        <div
          className='flex  fit-container cursor-pointer expand-collapse-cell'
          onClick={handleRowExpandCollapse}>
          {isChildExists && (
            <img
              className={classNames(
                'expand-collapse-icon',
                // { "visibilty-not-hidden": isChildExists },
                // { "visible-hidden": !isChildExists }
              )}
              src={imgSrc}></img>
          )}
        </div>
      );
    }
    const column: DocumentFieldValuesEntity = props.data.values.find(
      (d: DocumentFieldValuesEntity) => d.field == props.customData?.code,
    );
    if (column != undefined) {
      let data = column.value;
      if (data == '---') {
        data = '-';
      }
      const isParentChildValueDiffers = checkWhetherChildValueDiffer(
        column,
        props.data.id,
        props.data.parent,
      );
      return (
        <TextTruncate
          containerClassName={classNames(
            'ag-cell-font-common',
            // props.data.read ? "text-read" : "text-unread",
            getCSSForLeaseStatus(isParentChildValueDiffers),
          )}
          line={selectedRowId == props.data.id ? maxNoOfLines : minNoOfLines}
          textElement='div'
          text={data}
        />
      );
    }

    return '';
  }

  const checkWhetherChildValueDiffer = (
    currentField: DocumentFieldValuesEntity,
    docId: string,
    parentId: string,
  ) => {
    if (selectedFilterData?.length > 0) {
      let filterDateWithRelatedUnmatchedDocs: DocumentEntity[] = [...selectedFilterData];
      if (unMatchedRelatedDocuments?.length > 0) {
        filterDateWithRelatedUnmatchedDocs = [
          ...filterDateWithRelatedUnmatchedDocs,
          ...unMatchedRelatedDocuments,
        ];
      }
      if (parentId === '') {
        if (parentsWithChildren.includes(docId)) {
          const childrensList = filterDateWithRelatedUnmatchedDocs
            ?.filter((el) => el.parent === docId)
            .sort((a, b) => Number(b.grpOrder) - Number(a.grpOrder));
          const childrenField = childrensList?.[0]?.values.filter(
            (el) => el.field === currentField.field,
          )[0];
          if (childrenField?.value !== undefined && currentField?.value !== undefined) {
            return (
              normalizeText(childrenField?.value) !== normalizeText(currentField?.value) &&
              expandedDocumentId === docId
            );
          } else {
            return false;
          }
        }
        return false;
      }
      const sibilingsList = filterDateWithRelatedUnmatchedDocs
        ?.filter((el) => el.parent === parentId)
        .sort((a, b) => Number(b.grpOrder) - Number(a.grpOrder));
      const currentChildIndex = sibilingsList?.findIndex((el) => el.id === docId);
      if (currentChildIndex === sibilingsList?.length - 1) {
        return false;
      } else {
        const youngerSibling = sibilingsList?.[currentChildIndex + 1]?.values?.filter(
          (el) => el.field === currentField.field,
        );
        if (youngerSibling?.[0]?.value !== undefined && currentField?.value !== undefined) {
          return normalizeText(youngerSibling?.[0]?.value) !== normalizeText(currentField?.value);
        } else {
          return false;
        }
      }
    } else {
      return false;
    }
  };

  const handleContextMenu = (e: any) => {
    e.preventDefault();
    displayMenu(e, props.data, MENU_SUB_TYPE.CONTEXT_MENU);
  };

  const handleRowExpandCollapse = () => {
    if (!isChildExists) return;

    const currentId = props.data.id;
    const isCurrentExpanded = expandedDocumentId === currentId;
    const hasDifferentExpanded = expandedDocumentId && expandedDocumentId !== currentId;

    // Collapse if clicking the already expanded row
    if (isCurrentExpanded) {
      dispatch(setDocumentExpanded(''));
      dispatch(rowCollapseUpdate(currentId));

      return;
    }

    // Collapse previous expanded row if exists
    if (hasDifferentExpanded) {
      dispatch(rowCollapseUpdate(expandedDocumentId));
    }

    // Expand current row
    const expandCurrentRow = () => {
      dispatch(setDocumentExpanded(currentId));
      dispatch(rowExpandUpdate(currentId)).then((res) => {
        if (res) {
          dispatch(
            setDocumentRowAsExpanded({
              clientId: selectedTab,
              id: currentId,
            }),
          );
        }
      });
    };
    expandCurrentRow();
  };
  return (
    <div
      style={{ width: '100%', whiteSpace: 'normal', overflow: 'visible' }}
      onContextMenu={handleContextMenu}>
      {getData()}
    </div>
  );
}

export default TableCell;
